import dayjs from 'dayjs';

const firstDateOfCurrentMonth = (date = new Date()) =>
  date.getDay() > 15
    ? dayjs(new Date(date.getFullYear(), date.getMonth(), 1))
    : dayjs(new Date(date.getFullYear(), date.getMonth() - 1, 1));

export { firstDateOfCurrentMonth };
